import { faCommentMedical } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { ComponentType, LazyExoticComponent } from 'react'
import { useIntl } from 'react-intl'

import { Badge } from '@babylon/core-ui'
import { useFormatMessage } from '@babylon/intl'

import { ENABLE_TELUS_ASYNC_CHAT } from '~/constants'
import {
  TelusAsyncChatPageInterface,
  TelusAsyncChatPageNavigationItemInterface,
} from '~/core/config/modules/generated/types'
import { NavigationLink } from '~/features/navigation'

import { useUnreadCount } from './UnreadCountContext'
import { useRefreshUnreadOnNavigation } from './useRefreshUnreadOnNavigation'

import messages from './Navigation.messages'

const MAX_NOTIFICATIONS_COUNT = 99

export const LazyTelusAsyncChatPage: LazyExoticComponent<
  ComponentType<TelusAsyncChatPageInterface>
> = React.lazy(() => import('./TelusAsyncChatPage'))

const TelusAsyncChatNavigationItemInner: React.FC<{ path: string }> = ({
  path,
}) => {
  const fm = useFormatMessage()
  const { unreadCount } = useUnreadCount()
  const intl = useIntl()

  // Refresh the unread count via the REST API on every route change
  useRefreshUnreadOnNavigation()

  const badge = unreadCount > 0 && (
    <Badge
      value={
        unreadCount > MAX_NOTIFICATIONS_COUNT
          ? `${intl.formatNumber(MAX_NOTIFICATIONS_COUNT)}+`
          : intl.formatNumber(unreadCount)
      }
    />
  )

  return (
    <NavigationLink
      data-testid="telus-async-chat-navigation-link"
      to={path}
      icon={
        <FontAwesomeIcon
          icon={faCommentMedical}
          style={{ height: 24, width: 24 }}
          color="#6B7785"
        />
      }
      badge={badge}
    >
      {fm(messages.telus_async_chat_text)}
    </NavigationLink>
  )
}

export const TelusAsyncChatPageNavigationItem: TelusAsyncChatPageNavigationItemInterface = ({
  path,
}) => {
  if (!ENABLE_TELUS_ASYNC_CHAT) {
    return null
  }

  return <TelusAsyncChatNavigationItemInner path={path} />
}
